import React, { useState } from 'react';
import { Mail, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const HeroSection = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
      setTimeout(() => setSubmitted(false), 3000);
      setEmail('');
    }
  };

  return (
    <section className="pt-[72px] bg-gradient-to-b from-[#f8faff] to-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="flex-1 max-w-xl"
          >
            <h1 className="text-4xl md:text-5xl lg:text-[52px] font-bold leading-[1.15] tracking-tight">
              <span className="text-[#2563EB]">Maximise Repeat Revenue</span>{' '}
              <span className="text-gray-900">with 10x easier personalisation</span>
            </h1>

            <p className="mt-6 text-base lg:text-lg text-gray-500 leading-relaxed max-w-lg">
              Unify customer data, generate insights, personalise marketing
              communications across SMS, Email, Whatsapp & Instagram to delight
              your loyal customers.
            </p>

            {/* Email Form */}
            <form onSubmit={handleSubmit} className="mt-10 flex items-center gap-2 max-w-md">
              <div className="relative flex-1">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter Your Email"
                  className="w-full pl-12 pr-4 py-3.5 border border-gray-200 rounded-full text-sm focus:outline-none focus:border-blue-400 bg-white"
                />
              </div>
              <button
                type="submit"
                className="w-12 h-12 flex items-center justify-center bg-[#2563EB] rounded-full hover:bg-[#1d4ed8] transition-colors flex-shrink-0"
              >
                <ArrowRight className="w-5 h-5 text-white" />
              </button>
            </form>
            {submitted && (
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="mt-3 text-sm text-green-600 font-medium"
              >
                Thank you for your request. We will be e-mailing you for more details.
              </motion.p>
            )}
          </motion.div>

          {/* Right Illustration */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex-1 flex justify-center"
          >
            <img
              src="https://cdn.prod.website-files.com/620353a026ae70e21288308a/653a350819cce92fb5fb534f_Hero%20section%20illustratio%20%202%20(1).webp"
              alt="Xeno CRM Platform Illustration"
              className="max-w-full w-[560px]"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
